import React, {useState} from 'react';

const RankingsAndLevelsContext = React.createContext({});

// @ts-ignore
const RankingsAndLevelsProvider = ({ children }) => {
    const [isLife, setIsLife] = useState<boolean>(true);

    return (
        <RankingsAndLevelsContext.Provider value={{isLife, setIsLife}} >
            {children}
        </RankingsAndLevelsContext.Provider>
    );
};

export {
    RankingsAndLevelsProvider,
    RankingsAndLevelsContext,
}
